<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list v-model="loading" :finished="finished"
              finished-text="~~~~~~~~~~~~~ 飘逸的底线 ~~~~~~~~~~~~~"
              @load="onLoad">
      <van-cell v-for="item in list" :key="item.id" :title="item.title"
                @click='onClickItem(item)' >
        <slot name='icon' v-if='item.status === 2'></slot> <!-- 图标 -->
      </van-cell>
    </van-list>
  </van-pull-refresh>
  
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  props: {
    list: {
      type: Array,
      default: () => new Array()
    },
    qc: {
      type: Object,
      default: () => new Object()
    }
  },
  methods: {
    onLoad() {
      this.$emit('load');
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    onClickItem(item) {
      this.$emit('clickItem', item);
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/base/BaseList.vue